// extracted by mini-css-extract-plugin
module.exports = {"editDiscountTable":"edit-discount-table-220","addIcon":"add-icon-5ef"};